import { FC } from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;
const SpinnerWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;
    height: 100%;
`;
export const SpinnerImg = styled.img<{ size: number }>`
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
    animation: ${spin} 0.8s linear infinite;
`;
export const Spinner: FC = () => {
    return (
        <SpinnerWrapper>
            <SpinnerImg size={35} src="/images/icons/Spinner.png" />
        </SpinnerWrapper>
    );
};

export const MiniSpinner: FC<{ size: number }> = ({ size }) => {
    return <SpinnerImg size={size} src="/images/icons/Spinner.png" />;
};

export const AbsoluteSpinner = styled(Spinner)`
    position: absolute;
`;
